import axios from "axios";
import Swal from "sweetalert2";
import {
  baseUrl,
  defaultAddErrorMessage,
  defaultUpdateErrorMessage,
  errorTranslate,
  objectifyForDropdown,
} from "../util";

export const addEnergyToBusiness = ({
  businessId,
  type,
  source,
  category,
  qty,
  unit,
  single_source,
  price,
  invoiceDate,
  invoiceNo,
  qtyConsumed,
  qtySold,
  qtyWasted,
  energyWasted,
  loading = null,
  setLoading = null,
  index,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  const boolTick =
    single_source === "Yes" || single_source === "Ja" ? "Yes" : "No";
  var data = JSON.stringify({
    type: type,
    source: source,
    category: category,
    qty: qty,
    unit: unit,
    single_source: boolTick,
    price_invoice: price || null,
    invoice_date: invoiceDate || null,
    invoice_number: invoiceNo || null,
    qty_consumed: qtyConsumed || null,
    qty_sold: qtySold || null,
    qty_wasted: qtyWasted || null,
    energy_wasted: energyWasted || null,
  });

  var config = {
    method: "post",
    url: baseUrl + "/api/business/" + businessId + "/external-power",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal) {
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      }
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      setErrorMessage(error.response.data);
      if (loading) setLoading("failed");
      if (use_swal) {
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultAddErrorMessage,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      }
    });
};

export const deleteEnergy = ({
  businessId,
  objectId,
  use_swal = false,
  loading = null,
  setLoading = null,
  callback,
}) => {
  var config = {
    method: "delete",
    url:
      baseUrl + "/api/business/" + businessId + "/external-power/" + objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: error,
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
    });
};

export const deleteWater = ({
  businessId,
  objectId,
  use_swal = false,
  loading = null,
  setLoading = null,
  callback,
}) => {
  var config = {
    method: "delete",
    url: baseUrl + "/api/business/" + businessId + "/water-source/" + objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: error,
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
    });
};

export const getMainEnergyList = ({
  businessId,
  objectId,
  objects,
  setObjects = function () {
    return;
  },
  setTotalObj = function () {
    return;
  },
  setTotalEnergy = function () {
    return;
  },
  setSystemBoundaryEnergy = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/external-power",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setTotalObj(response.data.total_obj);
      setTotalEnergy(response.data.total_energy);
      setSystemBoundaryEnergy(response.data.total_obj.systemboundary_category);
      const sortedData = response.data.data
        .filter((data) => data.category === "main")
        .map((data) => {
          data.single_source = data.single_source ? "Yes" : "No";
          data.type = objectifyForDropdown(data.type);
          data.source = objectifyForDropdown(data.source);
          return data;
        })
        .sort((a, b) => {
          const dateA = new Date(a.created_at);
          const dateB = new Date(b.created_at);
          return dateA - dateB;
        });

      setObjects(sortedData);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getHomeProducedEnergyList = ({
  businessId,
  objectId,
  objects,
  setObjects,
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/external-power",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(
        response.data.data
          .filter((data) => {
            if (data.category === "home-produced") return true;
          })
          .map((data) => {
            data.type = objectifyForDropdown(data.type);
            data.source = objectifyForDropdown(data.source);
            return data;
          })
      );
    })
    .catch(function (error) {
      console.log(error);
      // setLoading(false)
      // Swal.fire({
      //   title: errorTranslate(),
      //   icon: 'error',
      //   text: error,
      //   confirmButtonColor: '#a9c1b4',
      //   // width: 600,
      //   // padding: '3em',
      //   color: '#476355',
      //   background: '#f1f8ef',
      // })
    });
};

export const getSymbioticEnergyList = ({
  businessId,
  objectId,
  objects,
  setObjects,
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/external-power",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(
        response.data.data
          .filter((data) => {
            if (data.category === "symbiotic") return true;
          })
          .map((data) => {
            data.single_source = data.single_source ? "Yes" : "No";
            data.type = objectifyForDropdown(data.type);
            data.source = objectifyForDropdown(data.source);
            return data;
          })
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updateEnergy = ({
  businessId,
  objectId,
  type,
  source,
  category,
  qty,
  unit,
  objects,
  single_source,
  price,
  invoiceDate,
  invoiceNo,
  qtyConsumed,
  qtySold,
  qtyWasted,
  energyWasted,
  setObjects = function () {
    return;
  },
  loading = null,
  setLoading = null,
  use_swal = false,
  callback,
  setErrorMessage = function () {
    return;
  },
}) => {
  var data = JSON.stringify({
    type: type,
    source: source,
    category: category,
    qty: qty,
    unit: unit,
    single_source: single_source,
    price_invoice: price || null,
    invoice_date: invoiceDate || null,
    invoice_number: invoiceNo || null,
    qty_consumed: Number(qtyConsumed) || null,
    qty_sold: qtySold || null,
    qty_wasted: qtyWasted || null,
    energy_wasted: energyWasted || null,
  });

  var config = {
    method: "put",
    url:
      baseUrl + "/api/business/" + businessId + "/external-power/" + objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      setErrorMessage();
      setObjects(
        objects.map((supply) => {
          if (response.data.data.id === supply.id) {
            response.data.data.type = objectifyForDropdown(
              response.data.data.type
            );
            response.data.data.source = objectifyForDropdown(
              response.data.data.source
            );
            response.data.data.single_source = response.data.data.single_source
              ? "Yes"
              : "No";
            return response.data.data;
          }
          return supply;
        })
      );
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      setErrorMessage(error.response.data);
      if (loading) setLoading("failed");

      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultUpdateErrorMessage,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
    });
};

export const getEnergy = ({ businessId, objectId, objects, setObjects }) => {
  var config = {
    method: "get",
    url:
      baseUrl + "/api/business/" + businessId + "/external-power/" + objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(
        objects.map((supply) => {
          const gotValue = response.data.data;

          if (gotValue.id === supply.id) {
            gotValue.type = objectifyForDropdown(gotValue.type);
            gotValue.source = objectifyForDropdown(gotValue.source);
            gotValue.single_source = gotValue.single_source ? "Yes" : "No";
            return gotValue;
          }
          // data.type =
          return supply;
        })
      );
    })
    .catch(function (error) {
      console.log(error);
      // setLoading(false)
      // Swal.fire({
      //   title: errorTranslate(),
      //   icon: 'error',
      //   text: error,
      //   confirmButtonColor: '#a9c1b4',
      //   // width: 600,
      //   // padding: '3em',
      //   color: '#476355',
      //   background: '#f1f8ef',
      // })
    });
};

export const addWaterToBusiness = async ({
  businessId,
  water_price,
  qty,
  category,
  subcategory,
  carbon,
  invoiceDate,
  invoiceNo,
  typeWater,
  typeUsedFor,
  type_equipment,
  typeDBWater,
  typeDBUsedFor,
  typeDBEquipment,
  price_invoice,
  materials,
  weight,
  manuel,
  isSubstitute,
  nickname,
  production_country,
  type_drinking,
  typedb_drinking,
  loading = null,
  setLoading = null,
  index,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  const boolTick =
    isSubstitute === "Yes" || isSubstitute === "Ja" ? "Yes" : "No";

  var data = JSON.stringify({
    water_price: water_price,
    qty: qty,
    category: category,
    carbon: carbon,
    subcategory: subcategory,
    invoice_date: invoiceDate || null,
    invoice_number: invoiceNo || null,
    type_water: typeWater,
    type_equipment: type_equipment,
    typedb_water: typeDBWater,
    typedb_equipment: typeDBEquipment,
    price_invoice: price_invoice || null,
    materials: materials,
    weight: weight,
    manuel: manuel,
    isSubstitute: boolTick,
    nickname: nickname,
    production_country: production_country,
    type_drinking: type_drinking || null,
    typedb_drinking: typedb_drinking || null,
  });

  var config = {
    method: "post",
    url: baseUrl + "/api/business/" + businessId + "/water-source",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");

  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal) {
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      }
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      setErrorMessage(error.response.data);
      if (loading) setLoading("failed");
      if (use_swal) {
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultAddErrorMessage,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      }
    });
};

export const getWater = ({
  businessId,
  objectId,
  objects,
  category,
  setObjects = function () {
    return;
  },
  setTotalObj = function () {
    return;
  },
  setSystemBoundaryWater = function () {
    return;
  },
  setTotalSavedWater = function () {
    return;
  },
  setWaterBill = function () {
    return;
  },
  setQty = function () {
    return;
  },
  setCarbon = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/water-source",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (response.data.data.length === 0) {
        addWaterToBusiness({ businessId: businessId });
        setWaterBill(0);
        setQty(0);
      } else {
        setTotalObj(response.data.total_obj);
        setTotalSavedWater(response.data.total_used);
        setSystemBoundaryWater(response.data.total_obj.systemboundary_category);
        const sortedData = response.data.data.sort((a, b) => {
          const dateA = new Date(a.created_at);
          const dateB = new Date(b.created_at);
          return dateA - dateB;
        });
        setObjects(sortedData);
        setWaterBill(response.data.data[0].water_price);
        setQty(response.data.data[0].qty);
        setCarbon(response.data.data[0].carbon);
      }
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getWaterUsage = ({
  businessId,
  objectId,
  objects,
  category,
  setObjects = function () {
    return;
  },
  setTotalObj = function () {
    return;
  },
  setSystemBoundaryWater = function () {
    return;
  },
  setTotalSavedWater = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/water-source",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setTotalObj(response.data.total_obj);
      setTotalSavedWater(response.data.total_used);
      setSystemBoundaryWater(response.data.total_obj.systemboundary_category);
      const sortedData = response.data.data
        .filter((data) => data.category === "used")
        .map((data) => {
          data.type_drinking = objectifyForDropdown(data.type_drinking);
          return data;
        })
        .sort((a, b) => {
          const dateA = new Date(a.created_at);
          const dateB = new Date(b.created_at);
          return dateA - dateB;
        });
      setObjects(sortedData);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getWaterLocational = ({
  businessId,
  objectId,
  objects,
  category,
  setObjects = function () {
    return;
  },
  setTotalObj = function () {
    return;
  },
  setSystemBoundaryWater = function () {
    return;
  },
  setTotalSavedWater = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/water-source",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setTotalObj(response.data.total_obj);
      setTotalSavedWater(response.data.total_used);
      setSystemBoundaryWater(response.data.total_obj.systemboundary_category);
      const sortedData = response.data.data
        .filter(
          (data) =>
            data.category === "found" &&
            (data.subcategory === "non_equipment_locational" ||
              data.subcategory === null)
        )
        .map((data) => {
          data.type_water = objectifyForDropdown(data.type_water);
          data.type_usedfor = objectifyForDropdown(data.type_usedfor);
          data.isSubstitute = data.isSubstitute === true ? "Yes" : "No";
          return data;
        })
        .sort((a, b) => {
          const dateA = new Date(a.created_at);
          const dateB = new Date(b.created_at);
          return dateA - dateB;
        });
      setObjects(sortedData);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getWaterLocationalEquipment = ({
  businessId,
  objectId,
  objects,
  category,
  setObjects = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/water-source",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const sortedData = response.data.data
        .filter(
          (data) =>
            data.category === "found" &&
            data.subcategory === "equipment_locational"
        )
        .map((data) => {
          data.type_equipment = objectifyForDropdown(data.type_equipment);
          data.materials = objectifyForDropdown(data.materials);
          data.nickname = objectifyForDropdown(data.nickname);
          data.production_country = objectifyForDropdown(
            data.production_country
          );
          return data;
        })
        .sort((a, b) => {
          const dateA = new Date(a.created_at);
          const dateB = new Date(b.created_at);
          return dateA - dateB;
        });
      setObjects(sortedData);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getWaterSymbioticEquipment = ({
  businessId,
  objectId,
  objects,
  category,
  setObjects = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/water-source",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const sortedData = response.data.data
        .filter(
          (data) =>
            data.category === "symbiotic" &&
            data.subcategory === "equipment_locational"
        )
        .map((data) => {
          data.type_equipment = objectifyForDropdown(data.type_equipment);
          data.materials = objectifyForDropdown(data.materials);
          data.nickname = objectifyForDropdown(data.nickname);
          data.production_country = objectifyForDropdown(
            data.production_country
          );
          return data;
        })
        .sort((a, b) => {
          const dateA = new Date(a.created_at);
          const dateB = new Date(b.created_at);
          return dateA - dateB;
        });
      setObjects(sortedData);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getWaterSymbiotic = ({
  businessId,
  objectId,
  objects,
  category,
  setObjects = function () {
    return;
  },
  setTotalObj = function () {
    return;
  },
  setSystemBoundaryWater = function () {
    return;
  },
  setTotalSavedWater = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/water-source",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setTotalObj(response.data.total_obj);
      setTotalSavedWater(response.data.total_used);
      setSystemBoundaryWater(response.data.total_obj.systemboundary_category);
      const sortedData = response.data.data
        .filter(
          (data) =>
            data.category === "symbiotic" &&
            (data.subcategory === "non_equipment_symbiotic" ||
              data.subcategory === null)
        )
        .map((data) => {
          data.type_water = objectifyForDropdown(data.type_water);
          data.type_usedfor = objectifyForDropdown(data.type_usedfor);
          data.isSubstitute = data.isSubstitute === true ? "Yes" : "No";
          return data;
        })
        .sort((a, b) => {
          const dateA = new Date(a.created_at);
          const dateB = new Date(b.created_at);
          return dateA - dateB;
        });
      setObjects(sortedData);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updateWater = ({
  businessId,
  objectId,
  objects,
  water_price,
  qty,
  category,
  subcategory,
  carbon,
  invoiceDate,
  invoiceNo,
  typeWater,
  type_equipment,
  typeDBWater,
  typeDBEquipment,
  price_invoice,
  materials,
  weight,
  manuel,
  isSubstitute,
  nickname,
  // setWaterBill = function () {
  //   return;
  // },
  // setQty = function () {
  //   return;
  // },
  // setCarbon = function () {
  //   return;
  // },
  setObjects = function () {
    return;
  },
  loading = null,
  setLoading = null,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  const boolTick = isSubstitute === "Yes" || isSubstitute === "Ja";

  var data = JSON.stringify({
    water_price: water_price,
    qty: qty,
    category: category,
    carbon: carbon,
    subcategory: subcategory,
    invoice_date: invoiceDate || null,
    invoice_number: invoiceNo || null,
    type_water: typeWater,
    type_equipment: type_equipment,
    typedb_water: typeDBWater,
    typedb_equipment: typeDBEquipment,
    price_invoice: price_invoice || null,
    materials: materials,
    weight: weight,
    manuel: manuel,
    isSubstitute: boolTick,
    nickname: nickname,
  });

  var config = {
    method: "put",
    url: baseUrl + "/api/business/" + businessId + "/water-source/" + objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");
  axios(config)
    .then(function (response) {
      setErrorMessage();
      setObjects(
        objects.map((supply) => {
          if (response.data.data.id === supply.id) {
            response.data.data.type_water = objectifyForDropdown(
              response.data.data.type_water
            );
            response.data.data.type_usedfor = objectifyForDropdown(
              response.data.data.type_usedfor
            );
            response.data.data.type_equipment = objectifyForDropdown(
              response.data.data.type_equipment
            );
            response.data.data.materials = objectifyForDropdown(
              response.data.data.materials
            );
            response.data.data.isSubstitute = response.data.data.isSubstitute
              ? "Yes"
              : "No";
            return response.data.data;
          }
          return supply;
        })
      );

      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
    })
    .catch(function (error) {
      setErrorMessage(error.response.data);
      if (loading) setLoading("failed");
      Swal.fire({
        title: errorTranslate(),
        icon: "error",
        text: defaultUpdateErrorMessage,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
    });
};

export const updateWaterEquipment = ({
  businessId,
  objectId,
  objects,
  water_price,
  qty,
  category,
  subcategory,
  carbon,
  invoiceDate,
  invoiceNo,
  typeWater,
  type_equipment,
  typeDBWater,
  typeDBEquipment,
  price_invoice,
  materials,
  weight,
  manuel,
  isSubstitute,
  nickname,
  production_country,
  setObjects = function () {
    return;
  },
  loading = null,
  setLoading = null,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  const boolTick = isSubstitute === "Yes" || isSubstitute === "Ja";

  var data = JSON.stringify({
    water_price: water_price,
    qty: qty,
    category: category,
    carbon: carbon,
    subcategory: subcategory,
    invoice_date: invoiceDate || null,
    invoice_number: invoiceNo || null,
    type_water: typeWater,
    type_equipment: type_equipment,
    typedb_water: typeDBWater,
    typedb_equipment: typeDBEquipment,
    price_invoice: price_invoice || null,
    materials: materials,
    weight: weight,
    manuel: manuel,
    isSubstitute: boolTick,
    nickname: nickname,
    production_country: production_country,
  });

  var config = {
    method: "put",
    url: baseUrl + "/api/business/" + businessId + "/water-source/" + objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");
  axios(config)
    .then(function (response) {
      setErrorMessage();
      setObjects(
        objects.map((supply) => {
          if (response.data.data.id === supply.id) {
            response.data.data.type_water = objectifyForDropdown(
              response.data.data.type_water
            );
            response.data.data.type_usedfor = objectifyForDropdown(
              response.data.data.type_usedfor
            );
            response.data.data.type_equipment = objectifyForDropdown(
              response.data.data.type_equipment
            );
            response.data.data.materials = objectifyForDropdown(
              response.data.data.materials
            );
            response.data.data.nickname = objectifyForDropdown(
              response.data.data.nickname
            );
            response.data.data.production_country = objectifyForDropdown(
              response.data.data.production_country
            );
            return response.data.data;
          }
          return supply;
        })
      );

      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
    })
    .catch(function (error) {
      setErrorMessage(error.response.data);
      if (loading) setLoading("failed");
      Swal.fire({
        title: errorTranslate(),
        icon: "error",
        text: defaultUpdateErrorMessage,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
    });
};

export const updateWaterUsed = ({
  businessId,
  qty,
  type_drinking,
  typedb_drinking,
  category,
  objectId,
  loading = null,
  setLoading = null,
  use_swal = false,
  callback = null,
  setObjects = function () {
    return;
  },
  objects,
}) => {
  var data = JSON.stringify({
    type_drinking: type_drinking,
    qty: qty,
    category: category,
    typedb_drinking: typedb_drinking,
  });

  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/water-source",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      var config = {
        method: "put",
        url:
          baseUrl + "/api/business/" + businessId + "/water-source/" + objectId,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then(function (response) {
          setObjects(
            objects.map((supply) => {
              if (response.data.data.id === supply.id) {
                response.data.data.type_drinking = objectifyForDropdown(
                  response.data.data.type_drinking
                );
                return response.data.data;
              }
              return supply;
            })
          );

          if (use_swal)
            Swal.fire({
              title: "Success!",
              icon: "success",
              // text: error,
              confirmButtonColor: "#a9c1b4",
              // width: 600,
              // padding: '3em',
              color: "#476355",
              background: "#f1f8ef",
            });
          if (loading) setLoading("success");
          if (callback) callback();
        })
        .catch(function (error) {
          Swal.fire({
            title: errorTranslate(),
            icon: "error",
            text: defaultUpdateErrorMessage,
            confirmButtonColor: "#a9c1b4",
            // width: 600,
            // padding: '3em',
            color: "#476355",
            background: "#f1f8ef",
          });
        });
    })
    .catch(function (error) {
      Swal.fire({
        title: errorTranslate(),
        icon: "error",
        text: error,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
    });
};

export const createSystemBoundaryCategories = ({
  businessId,
  systemBoundaryCategory,
  categoryName,
  loading = null,
  setLoading = null,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  var data = JSON.stringify({
    systemboundary_category: systemBoundaryCategory,
    category_name: categoryName,
  });

  var config = {
    method: "put",
    url: baseUrl + "/api/business/" + businessId + "/system-boundary",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal) {
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      }
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      setErrorMessage(error.response.data);
      if (loading) setLoading("failed");
      if (use_swal) {
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultAddErrorMessage,
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      }
    });
};
